// 預設鼓組配置 - 基於實際可用的音檔
export const PRESET_DRUMSETS = {
  basic: {
    key: "basic",
    nameKey: "drumKits.basic",
    description: "Simple 3-piece kit for beginners",
    instruments: [
      { id: "BD", name: "Kick", type: "kick", sampleId: "kick-classic", color: "bg-green-600" },
      { id: "SD", name: "Snare", type: "snare", sampleId: "snare-analog", color: "bg-red-600" },
      { id: "CH", name: "Hi-Hat", type: "hihat", sampleId: "hihat-acoustic01", color: "bg-yellow-600" }
    ]
  },
  
  standard: {
    key: "standard",
    nameKey: "drumKits.standard",
    description: "Full acoustic drum kit",
    instruments: [
      { id: "BD", name: "Kick", type: "kick", sampleId: "kick-acoustic01", color: "bg-green-600" },
      { id: "SD", name: "Snare", type: "snare", sampleId: "snare-acoustic01", color: "bg-red-600" },
      { id: "CH", name: "Hi-Hat", type: "hihat", sampleId: "hihat-acoustic01", color: "bg-yellow-600" },
      { id: "OH", name: "Open Hat", type: "openhat", sampleId: "openhat-acoustic01", color: "bg-yellow-300" },
      { id: "T1", name: "High Tom", type: "tom", sampleId: "tom-acoustic01", color: "bg-blue-400" },
      { id: "T2", name: "Low Tom", type: "tom", sampleId: "tom-acoustic02", color: "bg-blue-500" },
      { id: "CR", name: "Crash", type: "crash", sampleId: "crash-acoustic", color: "bg-orange-600" },
      { id: "RD", name: "Ride", type: "ride", sampleId: "ride-acoustic01", color: "bg-orange-400" }
    ]
  },
  
  electronic: {
    key: "electronic", 
    nameKey: "drumKits.electronic",
    description: "Classic 808 electronic drums",
    instruments: [
      { id: "BD", name: "808 Kick", type: "kick", sampleId: "kick-808", color: "bg-green-600" },
      { id: "SD", name: "808 Snare", type: "snare", sampleId: "snare-808", color: "bg-red-600" },
      { id: "CH", name: "808 Hi-Hat", type: "hihat", sampleId: "hihat-808", color: "bg-yellow-600" },
      { id: "OH", name: "808 Open Hat", type: "openhat", sampleId: "openhat-808", color: "bg-yellow-300" },
      { id: "CP", name: "808 Clap", type: "clap", sampleId: "clap-808", color: "bg-purple-400" },
      { id: "T1", name: "808 Tom", type: "tom", sampleId: "tom-808", color: "bg-blue-400" },
      { id: "CR", name: "808 Crash", type: "crash", sampleId: "crash-808", color: "bg-orange-600" },
      { id: "CB", name: "808 Cowbell", type: "percussion", sampleId: "cowbell-808", color: "bg-pink-500" }
    ]
  },

  // 新增：搖滾鼓組
  rock: {
    key: "rock",
    nameKey: "drumKits.rock",
    description: "Punchy rock drum kit",
    instruments: [
      { id: "BD", name: "Big Kick", type: "kick", sampleId: "kick-big", color: "bg-green-600" },
      { id: "SD", name: "Punch Snare", type: "snare", sampleId: "snare-punch", color: "bg-red-600" },
      { id: "CH", name: "Tight Hi-Hat", type: "hihat", sampleId: "hihat-acoustic02", color: "bg-yellow-600" },
      { id: "OH", name: "Slick Open Hat", type: "openhat", sampleId: "openhat-slick", color: "bg-yellow-300" },
      { id: "T1", name: "High Tom", type: "tom", sampleId: "tom-acoustic01", color: "bg-blue-400" },
      { id: "T2", name: "Low Tom", type: "tom", sampleId: "tom-acoustic02", color: "bg-blue-500" },
      { id: "CR", name: "Rock Crash", type: "crash", sampleId: "crash-acoustic", color: "bg-orange-600" }
    ]
  },

  // 新增：放克鼓組
  funk: {
    key: "funk",
    nameKey: "drumKits.funk",
    description: "Tight and funky drum kit",
    instruments: [
      { id: "BD", name: "Tight Kick", type: "kick", sampleId: "kick-tight", color: "bg-green-600" },
      { id: "SD", name: "Analog Snare", type: "snare", sampleId: "snare-analog", color: "bg-red-600" },
      { id: "CH", name: "Analog Hi-Hat", type: "hihat", sampleId: "hihat-analog", color: "bg-yellow-600" },
      { id: "OH", name: "Tight Open Hat", type: "openhat", sampleId: "openhat-tight", color: "bg-yellow-300" },
      { id: "CP", name: "Fat Clap", type: "clap", sampleId: "clap-fat", color: "bg-purple-400" },
      { id: "T1", name: "Short Tom", type: "tom", sampleId: "tom-short", color: "bg-blue-400" }
    ]
  },

  // 新增：迪斯科鼓組  
  disco: {
    key: "disco",
    nameKey: "drumKits.disco",
    description: "Four-on-the-floor disco kit",
    instruments: [
      { id: "BD", name: "Deep Kick", type: "kick", sampleId: "kick-deep", color: "bg-green-600" },
      { id: "SD", name: "Big Snare", type: "snare", sampleId: "snare-big", color: "bg-red-600" },
      { id: "CH", name: "Digital Hi-Hat", type: "hihat", sampleId: "hihat-digital", color: "bg-yellow-600" },
      { id: "OH", name: "Analog Open Hat", type: "openhat", sampleId: "openhat-analog", color: "bg-yellow-300" },
      { id: "CP", name: "Analog Clap", type: "clap", sampleId: "clap-analog", color: "bg-purple-400" },
      { id: "CR", name: "Tape Crash", type: "crash", sampleId: "crash-tape", color: "bg-orange-600" }
    ]
  },

  // 新增：爵士鼓組
  jazz: {
    key: "jazz",
    nameKey: "drumKits.jazz",
    description: "Classic jazz drum kit",
    instruments: [
      { id: "BD", name: "Soft Kick", type: "kick", sampleId: "kick-softy", color: "bg-green-600" },
      { id: "SD", name: "Vintage Snare", type: "snare", sampleId: "snare-vinyl01", color: "bg-red-600" },
      { id: "CH", name: "Vintage Hi-Hat", type: "hihat", sampleId: "hihat-acoustic01", color: "bg-yellow-600" },
      { id: "OH", name: "Classic Open Hat", type: "openhat", sampleId: "openhat-acoustic01", color: "bg-yellow-300" },
      { id: "RD", name: "Jazz Ride", type: "ride", sampleId: "ride-acoustic01", color: "bg-orange-400" },
      { id: "CR", name: "Jazz Crash", type: "crash", sampleId: "crash-acoustic", color: "bg-orange-600" }
    ]
  },

  // 新增：拉丁鼓組
  latin: {
    key: "latin",
    nameKey: "drumKits.latin",
    description: "Latin percussion kit",
    instruments: [
      { id: "BD", name: "Stomp Kick", type: "kick", sampleId: "kick-stomp", color: "bg-green-600" },
      { id: "SD", name: "Block Snare", type: "snare", sampleId: "snare-block", color: "bg-red-600" },
      { id: "CH", name: "Plain Hi-Hat", type: "hihat", sampleId: "hihat-plain", color: "bg-yellow-600" },
      { id: "CP", name: "Slapper Clap", type: "clap", sampleId: "clap-slapper", color: "bg-purple-400" },
      { id: "CB", name: "Cowbell", type: "percussion", sampleId: "cowbell-808", color: "bg-pink-500" },
      { id: "SH", name: "Shaker", type: "percussion", sampleId: "shaker-analog", color: "bg-pink-400" },
      { id: "PC", name: "Tribal Perc", type: "percussion", sampleId: "perc-tribal", color: "bg-pink-600" }
    ]
  },

  // 新增：斷拍鼓組
  breakbeat: {
    key: "breakbeat",
    nameKey: "drumKits.breakbeat",
    description: "Gritty breakbeat kit",
    instruments: [
      { id: "BD", name: "Gritty Kick", type: "kick", sampleId: "kick-gritty", color: "bg-green-600" },
      { id: "SD", name: "Brute Snare", type: "snare", sampleId: "snare-brute", color: "bg-red-600" },
      { id: "CH", name: "Dist Hi-Hat", type: "hihat", sampleId: "hihat-dist01", color: "bg-yellow-600" },
      { id: "OH", name: "Analog Open Hat", type: "openhat", sampleId: "openhat-analog", color: "bg-yellow-300" },
      { id: "CP", name: "Crushed Clap", type: "clap", sampleId: "clap-crushed", color: "bg-purple-400" },
      { id: "T1", name: "Lo-Fi Tom", type: "tom", sampleId: "tom-lofi", color: "bg-blue-400" },
      { id: "CR", name: "Noise Crash", type: "crash", sampleId: "crash-noise", color: "bg-orange-600" }
    ]
  },

  // 新增：Lo-Fi鼓組
  lofi: {
    key: "lofi",
    nameKey: "drumKits.lofi",
    description: "Vintage lo-fi drums",
    instruments: [
      { id: "BD", name: "Vinyl Kick", type: "kick", sampleId: "kick-vinyl01", color: "bg-green-600" },
      { id: "SD", name: "Lo-Fi Snare", type: "snare", sampleId: "snare-lofi01", color: "bg-red-600" },
      { id: "CH", name: "Tape Hi-Hat", type: "hihat", sampleId: "hihat-acoustic01", color: "bg-yellow-600" },
      { id: "OH", name: "Vintage Open Hat", type: "openhat", sampleId: "openhat-acoustic01", color: "bg-yellow-300" },
      { id: "CP", name: "Tape Clap", type: "clap", sampleId: "clap-tape", color: "bg-purple-400" },
      { id: "T1", name: "Lo-Fi Tom", type: "tom", sampleId: "tom-lofi", color: "bg-blue-400" },
      { id: "CR", name: "Tape Crash", type: "crash", sampleId: "crash-tape", color: "bg-orange-600" }
    ]
  },

  chillhop: {
    key: "chillhop",
    nameKey: "drumKits.chillhop",
    description: "Lo-Fi Chillhop Kit",
    instruments: [
      { id: "BD", name: "Lo-Fi Kick", type: "kick", sampleId: "kick-vinyl01", color: "bg-green-700" },
      { id: "SD", name: "Soft Snare", type: "snare", sampleId: "snare-lofi02", color: "bg-red-400" },
      { id: "CH", name: "Chill Hi-Hat", type: "hihat", sampleId: "hihat-plain", color: "bg-yellow-500" },
      { id: "OH", name: "Soft Open Hat", type: "openhat", sampleId: "openhat-tight", color: "bg-yellow-300" },
      { id: "CP", name: "Tape Clap", type: "clap", sampleId: "clap-tape", color: "bg-purple-300" },
      { id: "CR", name: "Noise Crash", type: "crash", sampleId: "crash-noise", color: "bg-orange-300" }
    ]
  },
};


// 可用的鼓件類型
export const DRUM_TYPES = [
  { id: "kick", nameKey: "drumTypes.kick", color: "bg-green-600" },
  { id: "snare", nameKey: "drumTypes.snare", color: "bg-red-600" },
  { id: "hihat", nameKey: "drumTypes.hihat", color: "bg-yellow-600" },
  { id: "openhat", nameKey: "drumTypes.openhat", color: "bg-yellow-300" },
  { id: "tom", nameKey: "drumTypes.tom", color: "bg-blue-500" },
  { id: "clap", nameKey: "drumTypes.clap", color: "bg-purple-400" },
  { id: "crash", nameKey: "drumTypes.crash", color: "bg-orange-600" },
  { id: "ride", nameKey: "drumTypes.ride", color: "bg-orange-400" },
  { id: "percussion", nameKey: "drumTypes.percussion", color: "bg-pink-500" }
];

// 獲取鼓組的輔助函數
export const getDrumKit = (key: string) => {
  return PRESET_DRUMSETS[key as keyof typeof PRESET_DRUMSETS];
};

// 獲取所有鼓組列表
export const getAllDrumKits = () => {
  return Object.values(PRESET_DRUMSETS);
};

// 獲取鼓件類型
export const getDrumType = (typeId: string) => {
  return DRUM_TYPES.find(type => type.id === typeId);
}; 
